/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import {
  Modal,
  Button,
  Form,
  FormGroup,
  ControlLabel,
  Col,
 } from 'react-bootstrap';
import Select from 'loracoms/Select';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import styles from './styles.scss';

const dataRateLabels = {
  fsk: (
    dr => (
      <span>
        {dr.dr}
        <span className={styles.infos}>
          <span className={styles.info}>
            <i className="fa fa-angle-left" />
            bit rate: {dr.bitrate}
            <i className="fa fa-angle-right" />
          </span>
        </span>
      </span>
    )),
  lora: (
    dr => (
      <span>
        {dr.dr}
        <span className={styles.infos}>
          <span className={styles.info}>
            <i className="fa fa-angle-left" />
            band width: {dr.bandwidth}k
            <i className="fa fa-angle-right" />
          </span>
          <span className={styles.info}>
            <i className="fa fa-angle-left" />
            SF: {dr.sf}
            <i className="fa fa-angle-right" />
          </span>
        </span>
      </span>
    )),
};

const propTypes = {
  intl: intlShape.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  channel: PropTypes.object.isRequired,
  dataRates: PropTypes.object.isRequired,
};

class EditDRModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      channel: props.channel,
      show: props.show,
      submitted: false,
      errors: ErrorSet.createEmpty(),
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.channelview.editdr');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderOptions = this.renderOptions.bind(this);
    this.handleChangeMinDR = this.handleChangeMinDR.bind(this);
    this.handleChangeMaxDR = this.handleChangeMaxDR.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { show, dataRates, channel } = nextProps;
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (dataRates !== this.props.dataRates) {
      this.setState({ dataRates });
    }
    this.setState({ channel, mindr: channel.mindr, maxdr: channel.maxdr });
  }

  handleChangeMinDR(mindr) {
    const { maxdr, errors } = this.state;
    this.setState({ mindr });

    if (!_.isNil(maxdr)) {
      if (maxdr < mindr) {
        this.setState({
          errors: errors.add('FE_MINGTMAX', 'mindr').add('FE_MINGTMAX', 'maxdr'),
        });
      } else {
        this.setState({
          errors: errors.remove('mindr').remove('maxdr'),
        });
      }
    } else {
      this.setState({
        errors: errors.remove('mindr'),
      });
    }
  }

  handleChangeMaxDR(maxdr) {
    const { mindr, errors } = this.state;
    this.setState({ maxdr });

    if (!_.isNil(mindr)) {
      if (maxdr < mindr) {
        this.setState({
          errors: errors.add('FE_MINGTMAX', 'mindr').add('FE_MINGTMAX', 'maxdr'),
        });
      } else {
        this.setState({
          errors: errors.remove('mindr').remove('maxdr'),
        });
      }
    } else {
      this.setState({
        errors: errors.remove('maxdr'),
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });

    const { channel, errors } = this.state;
    const {
      mindr = channel.mindr,
      maxdr = channel.maxdr,
    } = this.state;
    const { onEdit } = this.props;

    if (!errors.isEmpty()) {
      return;
    }
    this.handleOnHide();
    onEdit({ ...channel, mindr, maxdr });
  }

  handleOnHide() {
    this.setState({ submitted: false });
    this.props.onHide();
  }

  renderOptions(channel) {
    const { dataRates: { lora = [], fsk = [] } = {} } = this.state;
    let drs;
    let type;
    if (lora.findIndex(l => l.dr === channel.mindr) >= 0) {
      type = 'lora';
      drs = lora;
    } else {
      type = 'fsk';
      drs = fsk;
    }
    const drOpts = drs.map(dr => ({
      label: dr.dr,
      value: dr.dr,
      formatter: () => dataRateLabels[type](dr),
    }));
    return drOpts || [];
  }

  render() {
    const { show, channel, errors, submitted, mindr, maxdr } = this.state;
    return (
      <Modal
        bsClass="aisz-modal-light"
        backdrop="static"
        show={show}
        onHide={() => this.handleOnHide()}
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('header')}
        </Modal.Header>
        <Modal.Body>
          <Form horizontal onSubmit={this.handleSubmit}>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('mindr')}&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <Select
                  value={mindr}
                  options={this.renderOptions(channel)}
                  onChange={s => this.handleChangeMinDR(s)}
                />
                <ControlTips
                  show={submitted && errors.has('mindr')}
                  message={this.intlMsg.errorMsg(errors.get('mindr'))}
                  azStyle="danger"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('maxdr')}&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <Select
                  value={maxdr}
                  options={this.renderOptions(channel)}
                  onChange={s => this.handleChangeMaxDR(s)}
                />
                <ControlTips
                  show={submitted && errors.has('maxdr')}
                  message={this.intlMsg.errorMsg(errors.get('maxdr'))}
                  azStyle="danger"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={6} mdOffset={3}>
                <Button
                  bsStyle="aisz-primary"
                  className={styles.fullWidth}
                  type="submit"
                >
                  {this.intlMsg.msg('button.confirm')}
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

EditDRModal.propTypes = propTypes;

export default injectIntl(EditDRModal);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ChannelView/coms/EditDRModal/index.jsx